/**
 *-------------------------------------------
 * apis in allServiceStop page
 *-------------------------------------------
 */

import { postData } from '../../request'
export function stopAllClient(body) {
    return postData('api/admin/stopALLClient', body, { customError: true })
}

export function activeAllClient(body) {
    return postData('api/admin/acitveALLClient', body, { customError: true })
}
